import SignatureFieldPreview from "./MobilePreviewItems/SignatureFieldPreview";
import SubTitleFieldPreview from "./MobilePreviewItems/SubTitleFieldPreview";
import TextFieldPreview from "./MobilePreviewItems/TextFieldPreview";
import TitleFieldPreview from "./MobilePreviewItems/TitleFieldPreview";
import CheckboxFieldPreview from "./MobilePreviewItems/CheckboxFieldPreview";
import PictureFieldPreview from "./MobilePreviewItems/PictureFieldPreview";
import InitialsFieldPreview from "./MobilePreviewItems/InitialsFieldPreview";
import RadioFieldPreview from "./MobilePreviewItems/RadioFieldPreview";
import VideoFieldPreview from "./MobilePreviewItems/VideoFieldPreview";

export const MobilePreviewcomponentMap: Record<string, any> = {
  title: TitleFieldPreview,
  subtitle: SubTitleFieldPreview,
  text: TextFieldPreview,
  signature: SignatureFieldPreview,
  checkbox: CheckboxFieldPreview,
  picture: PictureFieldPreview,
  input: InitialsFieldPreview,
  radio: RadioFieldPreview,
  video: VideoFieldPreview,
};
